import type { SVGProps } from 'react'
const IconPencilOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.91 11.762a.75.75 0 0 1-.443-.145l-5.5-4.039a.751.751 0 1 1 .892-1.209l5.5 4.04a.75.75 0 0 1-.445 1.353z"
    />
    <path
      fill="currentColor"
      d="M7.677 20.498a2.67 2.67 0 0 1-2.66-2.65L5 16.072a4.85 4.85 0 0 1 .886-2.831l6.465-8.966a3.106 3.106 0 0 1 4.333-.683l1.734 1.264a3.1 3.1 0 0 1 .68 4.331l-6.39 8.861a4.87 4.87 0 0 1-2.61 1.863l-1.668.485q-.369.105-.753.102m7.18-16a1.6 1.6 0 0 0-1.3.657L7.105 14.11a3.34 3.34 0 0 0-.605 1.954l.016 1.775a1.17 1.17 0 0 0 1.5 1.111l1.666-.484a3.37 3.37 0 0 0 1.804-1.292l6.394-8.867a1.6 1.6 0 0 0-.349-2.239l-1.734-1.264a1.6 1.6 0 0 0-.94-.306"
    />
  </svg>
)
export default IconPencilOutlineIcon
